module.exports = __webpack_public_path__ + "static/assets/barcode.463b7b80.jpg";